import { styled } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const Text = styled("p")(({ theme }) => ({
  margin: "0 0 1rem 0",
  padding: "0 1rem",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 300,
  lineHeight: "22px",
  letterSpacing: "0.01em",
  textAlign: "center",
  "> strong": {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "22px",
    letterSpacing: "0.01em",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
    lineHeight: "30px",
    "> strong": {
      fontSize: "16px",
      lineHeight: "30px",
    },
  },
}));

const SectionText = () => {
  const { t } = useTranslation();

  return <Text dangerouslySetInnerHTML={{ __html: t("ppp.text") }} />;
};

export default SectionText;
